import RequiredValidator from "@/validators/RequiredValidator";

export default class PlanningEntryRules {

	public static readonly orderIdRules = [
		(new RequiredValidator('order.singular')).validationRule(),
	];

	public static readonly dateRules = [
		(new RequiredValidator('planningEntry.date')).validationRule(),
	];

}
